function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
import "core-js/modules/es.function.bind.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.object.set-prototype-of.js";
import "core-js/modules/es.object.get-prototype-of.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.object.create.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import ReactQuill, { Quill } from 'react-quill';
import InputLabel from "../core/input/InputLabel";
import { HtmlEditorWrapper, StyledQuillWrapper, TextAreaWrapper, TextAreaToolbar } from "./style";
import { _InputWrapperDiv } from "../core/input/inputStyles";
var validSizes = ['13px', '9px', '11px', '13px', '15px', '17px', '21px', '25px', '30px'];
var Size = Quill["import"]('attributors/style/size');
Size.whitelist = validSizes;
Quill.register(Size, true);

/*
  Quill does not lets us set `tabindex` to '-1' on the component it creates.
  So, we traverse the DOM under `ql-toolbar` to remove all `tabindex` instances
  on `span` elements and set `tabindex` to '-1' on all buttons or other elements
  that have `tabindex` set.
 */
var removeTabStops = function removeTabStops(rootNode) {
  try {
    if (rootNode) {
      if (!rootNode.tagName) return; // Ignore text elements

      if (rootNode.tagName.toLowerCase() === 'span') {
        rootNode.removeAttribute('tabindex');
      } else if (rootNode.tagName.toLowerCase() === 'button') {
        rootNode.setAttribute('tabindex', '-1');
      } else {
        var tabindex = rootNode.getAttribute('tabindex');
        if (tabindex !== undefined && tabindex !== '-1') {
          rootNode.setAttribute('tabindex', '-1');
        }
      }
      if (rootNode.childNodes && rootNode.childNodes.length > 0) {
        for (var i = 0; i < rootNode.childNodes.length; i++) {
          removeTabStops(rootNode.childNodes[i]);
        }
      }
    } else {
      var myNode = document.getElementsByClassName('ql-toolbar');
      if (!myNode || myNode.length <= 0) return;
      for (var _i = 0; _i < myNode.length; _i++) {
        removeTabStops(myNode[_i]);
      }
    }
  } catch (err) {
    console.error('error removing tabstops:', rootNode, err);
  }
};
var HtmlEditor = /*#__PURE__*/function (_React$Component) {
  _inherits(HtmlEditor, _React$Component);
  var _super = _createSuper(HtmlEditor);
  function HtmlEditor(props) {
    var _this;
    _classCallCheck(this, HtmlEditor);
    _this = _super.call(this, props);
    if ((props.value || props.input && props.input.value) && props.defaultValue) {
      console.error('HtmlEditor component: You cannot provide both value and defaultValue props at the same time!');
    }
    _this.onChange = _this.onChange.bind(_assertThisInitialized(_this));
    _this.editRawHtml = _this.editRawHtml.bind(_assertThisInitialized(_this));
    _this.toggleRaw = _this.toggleRaw.bind(_assertThisInitialized(_this));
    var link = ['link'];
    _this.modules = {
      toolbar: {
        container: [[{
          header: [1, 2, false]
        }, {
          size: validSizes
        }], ['bold', 'italic', 'underline', 'strike', 'blockquote'], [{
          list: 'ordered'
        }, {
          list: 'bullet'
        }, {
          indent: '-1'
        }, {
          indent: '+1'
        }], link, [{
          color: []
        }, {
          background: []
        }], ['clean']],
        handlers: {
          raw: _this.toggleRaw
        }
      }
    };
    try {
      if (props.sourceEditor) {
        _this.modules.toolbar.container.push(['raw']);
      }
    } catch (err) {
      console.error('HtmlEditor(): cannot activate sourceEditor.');
      console.error(err);
    }
    _this.formats = ['header', 'size', 'bold', 'italic', 'underline', 'strike', 'blockquote', 'list', 'bullet', 'indent', 'link', 'color', 'background'];
    try {
      if (props.hideHyperlink) {
        _this.modules.toolbar.container.splice(_this.modules.toolbar.container.indexOf(link), 1);
        _this.formats.splice(_this.formats.indexOf('link'), 1);
      }
    } catch (err) {
      console.error('HtmlEditor(): cannot remove hyperlink tool');
      console.error(err);
    }
    _this.state = {
      rawEditorVisible: false,
      rawHtml: '',
      editorHtml: props.value || props.defaultValue || props.input && props.input.value || ''
    };
    return _this;
  }
  _createClass(HtmlEditor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.attachQuillRefs();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.attachQuillRefs();
    }

    // eslint-disable-next-line react/no-deprecated
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.value) {
        if (!this.state.rawEditorVisible && nextProps.value !== this.state.editorHtml) {
          this.setState({
            editorHtml: nextProps.value
          });
        }
        if (this.state.rawEditorVisible && nextProps.value !== this.state.rawHtml) {
          this.setState({
            rawHtml: nextProps.value
          });
        }
      }
      if (nextProps.input) {
        if (!this.state.rawEditorVisible && nextProps.input.value !== this.state.editorHtml) {
          this.setState({
            editorHtml: nextProps.input.value
          });
        }
        if (this.state.rawEditorVisible && nextProps.value !== this.state.rawHtml) {
          this.setState({
            rawHtml: nextProps.input.value
          });
        }
      }
    }
  }, {
    key: "attachQuillRefs",
    value: function attachQuillRefs() {
      if (!this.reactQuillRef) return;
      // Ensure React-Quill reference is available:
      if (typeof this.reactQuillRef.getEditor !== 'function') return;
      // Skip if Quill reference is defined:
      if (this.quillRef != null) return;
      var quillRef = this.reactQuillRef.getEditor();
      if (quillRef != null) this.quillRef = quillRef;
      if (this.props.quillRef) {
        this.props.quillRef(quillRef);
      }
      removeTabStops();
    }
  }, {
    key: "onChange",
    value: function onChange(value) {
      var _this2 = this;
      if (this.state.editorHtml === value) return;
      var removePValue = value.substring(3, value.length - 4);
      if (this.state.editorHtml === removePValue) return;
      this.setState({
        editorHtml: value
      }, function () {
        if (_this2.props.onChange && typeof _this2.props.onChange === 'function') {
          _this2.props.onChange(value);
        } else if (_this2.props.input && _this2.props.input.onChange) {
          _this2.props.input.onChange(value);
        }
      });
    }
  }, {
    key: "editRawHtml",
    value: function editRawHtml(event) {
      var _this3 = this;
      var value = event.target.value;
      this.setState({
        rawHtml: value
      }, function () {
        if (_this3.props.onChange && typeof _this3.props.onChange === 'function') {
          _this3.props.onChange(value);
        }
      });
    }
  }, {
    key: "toggleRaw",
    value: function toggleRaw() {
      if (this.state.rawEditorVisible) {
        this.setState({
          editorHtml: this.state.rawHtml,
          rawEditorVisible: false,
          rawHtml: ''
        });
      } else {
        this.setState({
          rawHtml: this.state.editorHtml,
          rawEditorVisible: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var rawEditorVisible = this.props.sourceEditor && this.state.rawEditorVisible;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_InputWrapperDiv, null, /*#__PURE__*/React.createElement(InputLabel, {
        labelText: this.props.labelText,
        required: this.props.required
      })), /*#__PURE__*/React.createElement(HtmlEditorWrapper, {
        styledInput: this.props.styledInput
      }, /*#__PURE__*/React.createElement(StyledQuillWrapper, {
        visible: !rawEditorVisible,
        error: this.props.error
      }, /*#__PURE__*/React.createElement(ReactQuill, {
        ref: function ref(quill) {
          return _this4.reactQuillRef = quill;
        },
        style: {
          backgroundColor: '#fff'
        },
        theme: "snow",
        modules: this.modules,
        formats: this.formats,
        onChange: this.onChange,
        value: this.state.editorHtml,
        readOnly: this.props.readOnly,
        "aria-label": this.props.labelText
      })), rawEditorVisible && /*#__PURE__*/React.createElement(TextAreaWrapper, null, /*#__PURE__*/React.createElement(TextAreaToolbar, null, /*#__PURE__*/React.createElement("button", {
        onClick: this.toggleRaw
      }, "Rich Editor")), /*#__PURE__*/React.createElement("textarea", {
        value: this.state.rawHtml,
        onChange: this.editRawHtml
      }))));
    }
  }]);
  return HtmlEditor;
}(React.Component);
HtmlEditor.propTypes = {
  defaultValue: PropTypes.string,
  sourceEditor: PropTypes.bool,
  value: PropTypes.string
};
HtmlEditor.defaultProps = {
  defaultValue: undefined,
  sourceEditor: false,
  value: undefined
};
export default HtmlEditor;